import { useEffect, useRef, useState } from 'react';
import NonStandardEquipment from './NonStandardEquipment';
import { formatPrice, formatVinSerial, getYearDropdownList, sanitizeE1Input } from "utils";
import { useDispatch, useSelector } from 'react-redux';
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction';
import { getVendorDetails } from 'Store/Organization/VendorDetails/VendorDetailsAction';
import { validateVinDuplicate, setVinValidationResult } from 'Store/Component/FleetManagement/FleetManagementAction';
import { IRequest } from 'Model/IRequest';
import { INonStandardEquipment } from 'Model/INonStandardEquipment';
import { IReason } from 'Model/IReason';
import { initializeReason } from 'client/utils/RequisitionUtil';
import ConfirmationBee from "../../../../../assets/images/ConfirmationBee.svg"
import Validation from "../NonStandardEquipment/NonStandardEquipmentValidation"
import { CONSTANTS } from "client/utils/constants";
import { useDebounce } from 'client/CommonComponents/CustomDebounce/DebounceHook';

const NonStandardEquipmentContainer = (props: any) => {
  const dispatch = useDispatch();
  const cloneDeep = <T,>(value: T): T => (value === undefined || value === null ? value : JSON.parse(JSON.stringify(value)));
  const order: INonStandardEquipment = {
    requestIndex: 0,
    requestType: '',
    requestId: 0,
    nonStandardEquipmentIndex: 0,
    orderTypeId: 0,
    make: '',
    model: '',
    year: 0,
    isUsed: false,
    vinSerial: '',
    pricePerUnit: 0,
    description: '',
    quantity: 1,
    abNumber: 0,
    vendorName: '',
    dealerContact: '',
    dealerPhone: 0,
    emailAddress: '',
    address1: '',
    address2: '',
    address3: '',
    city: '',
    state: '',
    zip: 0,
    isExistInCart: false
  }
  const [orderDetails, setOrderDetails] = useState<any>(order);
  
  const [vendorDropdownList, setVendorDropdownList] = useState<any>([]);
  const yearDropdownList = getYearDropdownList();
  const usedDropdownList = [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
  ]

  const NonStandardRef = useRef<any>([]);
  const originalVinSerialRef = useRef<string>('');
  useEffect(() => {
    fieldFocus()
  }, [])

  const initializeNonStandardEquipmentValidation = {
    makeError: '',
    modelError: '',
    yearError: '',
    isUsedError: '',
    vinOrSerialNoError: '',
    pricePerUnitError: '',
    vendorNameError: '',
    dealerContactError: '',
    dealerPhoneError: '',
    emailAddressError: '',
    address1Error: '',
    cityError: '',
    stateError: '',
    zipError: '',
    vinSerialError: '',
    descriptionError: '',
    address2Error: '',
    address3Error: ''
  }
  const [nonStandardEquipmentValidation, setNonStandardEquipmentValidation] = useState<any>(initializeNonStandardEquipmentValidation);

  const [popupContent, setPopupContent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
  });
  const duplicateVinWarningMessage = "The VIN/Serial# that you have entered already exists on an item in this order.";

  ///selectors
  const { selectedRequisitionType, vendorDetails, requestList, nonStandardEquipmentList, nonStandardEquipmentCartList, reasonList, editRequestDetails, isEditRequestClick, vinValidationResult }: any = useSelector((state?: any) => ({    
    selectedRequisitionType: state.RequisitionReducer.selectedRequisitionType,
    vendorDetails: state.VendorDetailsReducer.vendorDropDownList,
    requestList: state.RequisitionReducer.requestList,
    nonStandardEquipmentList: state.RequisitionReducer.nonStandardEquipmentList,
    nonStandardEquipmentCartList: state.RequisitionReducer.nonStandardEquipmentCartList,
    reasonList: state.RequisitionReducer.reasonList,
    editRequestDetails: state.RequisitionReducer.editRequestDetails,
    isEditRequestClick: state.RequisitionReducer.isEditRequestClick,
    vinValidationResult: state.fleetAdminTaskReducer?.vinValidationResult
  }));

  const refreshuuid = props.uniqueRefreshUUid;
  useEffect(() => {
    if (editRequestDetails?.requestType !== CONSTANTS.NON_STANDARD_EQUIPMENT) {
      dispatch(getVendorDetails(""));
      setOrderDetails(order);
      setVendor({});
      originalVinSerialRef.current = ''; 
    }
  }, [refreshuuid])

  

  useEffect(() => {
    ///Modified dropDown values as required
    const list = Array.isArray(vendorDetails)
      ? vendorDetails.map((item: any) => (
          { text: item.alphaName, value: item.alphaName, label: item.abnumber + "-" + item.alphaName, key: item.abnumber, ...item }
        ))
      : [];
    setVendorDropdownList(list);
  }, [vendorDetails])

  const validation = (orderDetail: any) => {

    let error = { ...nonStandardEquipmentValidation };

    error = { ...Validation.ValidateMake(orderDetail, error) };
    error = { ...Validation.ValidateModel(orderDetail, error) };
    error = { ...Validation.ValidateYear(orderDetail, error) };
    error = { ...Validation.ValidateIsUsed(orderDetail, error) };
    error = { ...Validation.ValidatePricePerUnit(orderDetail, error) };
    error = { ...Validation.ValidateVendorName(orderDetail, error) };
    error = { ...Validation.ValidateDealerContact(orderDetail, error) };
    error = { ...Validation.ValidateDealerPhone(orderDetail, error) };
    error = { ...Validation.ValidateEmailAddress(orderDetail, error) };
    error = { ...Validation.ValidateAddress1(orderDetail, error) };
    error = { ...Validation.ValidateCity(orderDetail, error) };
    error = { ...Validation.ValidateState(orderDetail, error) };
    error = { ...Validation.ValidateZip(orderDetail, error) };

    setNonStandardEquipmentValidation(error);
    return error;
  }

  const onChangeMake = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.make = item.target.value;
      let error = { ...Validation.ValidateMake(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
  }
  const onChangeModel = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.model = item.target.value;
      let error = { ...Validation.ValidateModel(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
  }
  const onChangeYear = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.year = item;
      let error = { ...Validation.ValidateYear(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
  }
  const onChangeIsUsed = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.isUsed = item;
      let error = { ...Validation.ValidateIsUsed(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
  }
  const onChangeVinSerial = (item: any) => {
    const formattedValue = formatVinSerial(item.target.value);
    
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.vinSerial = formattedValue;
    let error = { ...Validation.ValidateVinSerial(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
    // Clear validation result when user modifies the field
    dispatch(setVinValidationResult(null));
  }

  const onBlurVinSerial = (vinSerial: string) => {
    const trimmedVinSerial = vinSerial?.trim() || '';
    const trimmedOriginalVin = originalVinSerialRef.current?.trim() || '';
 
    if (!trimmedVinSerial || trimmedOriginalVin === trimmedVinSerial) {
        originalVinSerialRef.current = trimmedVinSerial;    
      return;
    }   
    originalVinSerialRef.current = trimmedVinSerial; 
    const currentOrderRequestDetailId = isEditRequestClick && editRequestDetails?.orderRequestDetailId 
      ? editRequestDetails.orderRequestDetailId 
      : null;
    dispatch(validateVinDuplicate({vinSerial: trimmedVinSerial, currentOrderRequestDetailId: currentOrderRequestDetailId}));
  };

  const onChangePricePerUnit = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    const val = item.target.value
    const regEx = /^[\d\.?\d,\b]*$/;
    const valArr = val.split('.')
    const checkNumber = regEx.test(val);
    if (!checkNumber || valArr.length > 2) {
      return;
    }
    else {
      orderDetailsTemp.pricePerUnit = item.target.value;
    }
      let error = { ...Validation.ValidatePricePerUnit(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
  }
  const onChangeDescription = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.description = sanitizeE1Input(item.target.value);
      let error = { ...Validation.ValidateDescription(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
  }

  const [vendorSearchText, setVendorSearchText] = useState<string>("");
  const [vendor, setVendor] = useState<any>({})
  const filterOptionVendor = (value: any, action: any) => {
    if (action.action === "input-change") {
      setVendorSearchText(value)
    }
  };

  const dealerSelectOnBlur = () => {
    setVendorSearchText('')
  }

  const searchQuery = useDebounce(vendorSearchText, 700)

  useEffect(() => {
    if (searchQuery?.length > 2) {
      dispatch(getVendorDetails(searchQuery.replace(/[^\w\s]/gi,"")));
    } else {
      dispatch(getVendorDetails(''))
    }
  }, [searchQuery])

  const onChangeVendorName = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    setVendor(item)
    orderDetailsTemp.abNumber = item.abnumber;
    orderDetailsTemp.vendorName = item.alphaName;
    orderDetailsTemp.dealerContact = item.mailingName;
    orderDetailsTemp.dealerPhone = item.phoneAreaCode + item.phoneNumber;
    orderDetailsTemp.emailAddress = "";
    orderDetailsTemp.address1 = item.address1;
    orderDetailsTemp.address2 = item.address2;
    orderDetailsTemp.address3 = item.address3;
    orderDetailsTemp.city = item.city;
    orderDetailsTemp.state = item.state;
    orderDetailsTemp.zip = item.postalCode;

      let error = { ...Validation.ValidateVendorName(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    error = { ...Validation.ValidateDealerContact(orderDetailsTemp, error) };
    error = { ...Validation.ValidateDealerPhone(orderDetailsTemp, error) };
    error = { ...Validation.ValidateAddress1(orderDetailsTemp, error) };
    error = { ...Validation.ValidateCity(orderDetailsTemp, error) };
    error = { ...Validation.ValidateState(orderDetailsTemp, error) };
    error = { ...Validation.ValidateZip(orderDetailsTemp, error) };

    setNonStandardEquipmentValidation(error);
    setVendorSearchText('')
    setOrderDetails(orderDetailsTemp);
  }

 

  const onChangeDealerContact = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.dealerContact = item.target.value;
      let error = { ...Validation.ValidateDealerContact(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
  }
  const onChangeDealerPhone = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.dealerPhone = item.target.value;
      let error = { ...Validation.ValidateDealerPhone(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
  }
  const onChangeEmailAddress = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.emailAddress = item.target.value;
      let error = { ...Validation.ValidateEmailAddress(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
  }
  const onChangeAddress1 = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.address1 = item.target.value;
      let error = { ...Validation.ValidateAddress1(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
  }
  const onChangeAddress2 = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.address2 = item.target.value;
      let error = { ...Validation.ValidateAddress2(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
  }
  const onChangeAddress3 = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.address3 = item.target.value;
      let error = { ...Validation.ValidateAddress3(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
  }
  const onChangeCity = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.city = item.target.value;
      let error = { ...Validation.ValidateCity(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
  }
  const onChangeState = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.state = item.target.value;
      let error = { ...Validation.ValidateState(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
  }
  const onChangeZip = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.zip = item.target.value;
      let error = { ...Validation.ValidateZip(orderDetailsTemp, { ...nonStandardEquipmentValidation }) };
    setNonStandardEquipmentValidation(error);
    setOrderDetails(orderDetailsTemp);
  }

  const unitPriceFormat = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.pricePerUnit = formatPrice(item.target.value, 2);
    if(orderDetailsTemp.pricePerUnit == "0.00")
    {
      orderDetailsTemp.pricePerUnit = null;
    }
    setOrderDetails(orderDetailsTemp);
  };

  const addOnClick = () => {
    dispatch(RequisitionAction.setIsAddToCartClick(false));
    props.setItemDetailComponent(true)

    //check validation
    let nonStandardEquipmentValidationError = validation(orderDetails);
    let validToShowItemDetail = true;

    for (let key in nonStandardEquipmentValidationError) {
      if (nonStandardEquipmentValidationError[key]) {
        validToShowItemDetail = false;
        return validToShowItemDetail
        //return validToShowItemDetail = false;
      }
    }
    if (validToShowItemDetail) {
      dispatch(RequisitionAction.setIsChangesOccured(true))
      props.setItemDetailComponent(true)
      dispatch(RequisitionAction.setShowItemDetails(true))

      //copy the global value      
      const requestListTemp = cloneDeep(requestList) ?? [];
      const nonStandardEquipmentListTemp = cloneDeep(nonStandardEquipmentList) ?? [];
      const nonStandardEquipmentCartListTemp = cloneDeep(nonStandardEquipmentCartList) ?? [];
      const reasonListTemp = cloneDeep(reasonList) ?? [];

      //check duplicate
      const nonStandardEquipment: INonStandardEquipment = {
        requestIndex: 0,
        requestType: '',
        requestId: 0,
        nonStandardEquipmentIndex: 0,
        orderTypeId: selectedRequisitionType.orderRequestTypeId,
        make: orderDetails.make,
        model: orderDetails.model,
        year: orderDetails.year.value,
        isUsed: orderDetails.isUsed.value,
        vinSerial: orderDetails.vinSerial,
        pricePerUnit: orderDetails.pricePerUnit,
        description: orderDetails.description,
        quantity: orderDetails.quantity ?? 1,
        abNumber: orderDetails.abNumber,
        vendorName: orderDetails.vendorName,
        dealerContact: orderDetails.dealerContact,
        dealerPhone: orderDetails.dealerPhone,
        emailAddress: orderDetails.emailAddress,
        address1: orderDetails.address1,
        address2: orderDetails.address2,
        address3: orderDetails.address3,
        city: orderDetails.city,
        state: orderDetails.state,
        zip: orderDetails.zip,
        isExistInCart: false
      };

      const normalizedVinSerial = (nonStandardEquipment.vinSerial || '').trim().toLowerCase();
      const isDuplicateVinInRequest = normalizedVinSerial.length > 0 && nonStandardEquipmentListTemp.some((item: any) =>
        (item?.vinSerial || '').trim().toLowerCase() === normalizedVinSerial
      );

      const proceedAddItem = (syncCartDealerDetails: boolean = false) => {
        //Request
        let nextRequestIndex = 0;
        requestListTemp.forEach((item : any) => {
          if (item?.requestIndex > nextRequestIndex) {
            nextRequestIndex = item?.requestIndex;
          }
        });
        nextRequestIndex = nextRequestIndex + 1;

        const request: IRequest = {
          requestIndex: nextRequestIndex,
          requestType: selectedRequisitionType.orderRequestType,
          showQuotePrice: false
        };
        requestListTemp.push(request);

        //NonStandard Equipment
        let nextNonStandardEquipmentIndex = 0;
        nonStandardEquipmentListTemp.forEach((item : any) => {
          if (item.nonStandardEquipmentIndex > nextNonStandardEquipmentIndex) {
            nextNonStandardEquipmentIndex = item.nonStandardEquipmentIndex;
          }
        });
        nextNonStandardEquipmentIndex = nextNonStandardEquipmentIndex + 1;

        //set the index
        nonStandardEquipment.requestIndex = request?.requestIndex;
        nonStandardEquipment.requestType = request?.requestType;
        nonStandardEquipment.nonStandardEquipmentIndex = nextNonStandardEquipmentIndex;

        nonStandardEquipmentListTemp.push(nonStandardEquipment);

        //Reason
        let nextReasonIndex = 0;
        reasonListTemp.forEach((item : any) => {
          if (item?.reasonIndex > nextReasonIndex) {
            nextReasonIndex = item?.reasonIndex;
          }
        });

        nextReasonIndex = nextReasonIndex + 1;
        const reason: IReason = initializeReason(request, nextReasonIndex);
        reasonListTemp.push(reason);

        dispatch(RequisitionAction.setIRequest(requestListTemp))
        dispatch(RequisitionAction.setINonStandardEquipment(nonStandardEquipmentListTemp))
        if (syncCartDealerDetails) {
          dispatch(RequisitionAction.setCartINonStandardEquipment(nonStandardEquipmentCartListTemp))
        }
        dispatch(RequisitionAction.setIReason(reasonListTemp))
        dispatch(setVinValidationResult(null));
      };

      const proceedAddItemWithDuplicateValidation = (syncCartDealerDetails: boolean = false) => {
        if (isDuplicateVinInRequest) {
          let description = (
            <>
              <p>{duplicateVinWarningMessage}</p>
            </>
          )
  
          setPopupContent({
            ...popupContent,
            titleImg: ConfirmationBee,
            title: "ALREADY EXISTS",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: description,
            primaryBtnText: "",
            outlineBtnText: "Ok",
            isSingleConfirmationBtn: true,
            popupOutlinebtnOnclick: () => {
              hideDialog();
              proceedAddItem(syncCartDealerDetails);
            },
            popupPrimarybtnOnclick: () => {
              hideDialog();
              proceedAddItem(syncCartDealerDetails);
            }
          });
          return;
        }

        proceedAddItem(syncCartDealerDetails);
      };

      const proceedAddItemWithDealerValidation = () => {
        const hasExistingRequestItems = nonStandardEquipmentListTemp.length > 0;
        const hasCartItems = nonStandardEquipmentCartListTemp.length > 0;
        const isDealerChangedInRequest = hasExistingRequestItems && nonStandardEquipmentListTemp.some((item: any) => !isDealerDetailsEqual(item, orderDetails));
        const isDealerChangedInCart = hasCartItems && nonStandardEquipmentCartListTemp.some((item: any) => !isDealerDetailsEqual(item, orderDetails));

        if (isDealerChangedInCart) {
          showDealerPropagationConfirmationPopup(() => {
            applyDealerDetailsToAllItems(nonStandardEquipmentListTemp, orderDetails);
            applyDealerDetailsToAllItems(nonStandardEquipmentCartListTemp, orderDetails);
            proceedAddItemWithDuplicateValidation(true);
          });
          return;
        }

        if (isDealerChangedInRequest) {
          showDealerPropagationPopup(() => {
            applyDealerDetailsToAllItems(nonStandardEquipmentListTemp, orderDetails);
            proceedAddItemWithDuplicateValidation();
          });
          return;
        }

        proceedAddItemWithDuplicateValidation();
      };
      proceedAddItemWithDealerValidation();
    }
  }
  const hideDialog = () => setPopupContent({ ...popupContent, isDialogVisible: false });

  const [showDealerVendorPopup, setShowDealerVendorPopup] = useState(false)
  const dealerVendorPopupClick = (e:any) => {
    e.preventDefault();
    setShowDealerVendorPopup(true)
  }

  const fieldFocus = () =>{
    NonStandardRef.current[0]?.focus()
  }

  const getDealerDetails = (item: any) => ({
    abNumber: item?.abNumber,
    vendorName: item?.vendorName,
    dealerContact: item?.dealerContact,
    dealerPhone: item?.dealerPhone,
    emailAddress: item?.emailAddress,
    address1: item?.address1,
    address2: item?.address2,
    address3: item?.address3,
    city: item?.city,
    state: item?.state,
    zip: item?.zip
  });

  const normalizeDealerField = (value: any) => (value ?? '').toString().trim().toLowerCase();

  const isDealerDetailsEqual = (left: any, right: any) => {
    const leftDealer = getDealerDetails(left);
    const rightDealer = getDealerDetails(right);
    const dealerKeys = Object.keys(leftDealer) as (keyof typeof leftDealer)[];

    return dealerKeys.every((key) =>
      normalizeDealerField(leftDealer[key]) === normalizeDealerField(rightDealer[key])
    );
  };

  const applyDealerDetailsToAllItems = (items: any[], source: any) => {
    const dealerDetails = getDealerDetails(source);
    items.forEach((item: any) => {
      item.abNumber = dealerDetails.abNumber;
      item.vendorName = dealerDetails.vendorName;
      item.dealerContact = dealerDetails.dealerContact;
      item.dealerPhone = dealerDetails.dealerPhone;
      item.emailAddress = dealerDetails.emailAddress;
      item.address1 = dealerDetails.address1;
      item.address2 = dealerDetails.address2;
      item.address3 = dealerDetails.address3;
      item.city = dealerDetails.city;
      item.state = dealerDetails.state;
      item.zip = dealerDetails.zip;
    });
  };

  const showDealerPropagationPopup = (onConfirm: () => void) => {
    let description = (
      <>
        <p>Dealer updated. All items on this order will reflect the newly selected dealer.</p>
      </>
    );

    setPopupContent({
      ...popupContent,
      titleImg: ConfirmationBee,
      title: "",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: description,
      primaryBtnText: "",
      outlineBtnText: "Ok",
      isSingleConfirmationBtn: true,
      popupOutlinebtnOnclick: () => {
        hideDialog();
        onConfirm();
      },
      popupPrimarybtnOnclick: () => {
        hideDialog();
        onConfirm();
      }
    });
  };

  const showDealerPropagationConfirmationPopup = (onConfirm: () => void) => {
    const description = (
      <>
        <p>The dealer will be updated for all items in this cart.</p>
        <p>Are you sure you want to continue?</p>
      </>
    );

    setPopupContent({
      ...popupContent,
      titleImg: ConfirmationBee,
      title: "CONFIRMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: description,
      primaryBtnText: "Ok",
      outlineBtnText: "Cancel",
      isSingleConfirmationBtn: false,
      popupOutlinebtnOnclick: () => {
        hideDialog();
      },
      popupPrimarybtnOnclick: () => {
        hideDialog();
        onConfirm();
      }
    });
  };

const updateOnClick = () => {
  dispatch(RequisitionAction.setIsAddToCartClick(false));
  props.setItemDetailComponent(true)

  //check validation
  let nonStandardEquipmentValidationError = validation(orderDetails);
  let validToShowItemDetail = true;

  for (let key in nonStandardEquipmentValidationError) {
    if (nonStandardEquipmentValidationError[key]) {
      validToShowItemDetail = false
      return validToShowItemDetail
    }
  }
  if (validToShowItemDetail) {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    props.setItemDetailComponent(true)
    dispatch(RequisitionAction.setShowItemDetails(true))

    const nonStandardEquipmentListTemp = cloneDeep(nonStandardEquipmentList) ?? [];
    const nonStandardEquipmentCartListTemp = cloneDeep(nonStandardEquipmentCartList) ?? [];
    const updatedOrder = {
      make: orderDetails.make,
      model: orderDetails.model,
      year: orderDetails.year?.value,
      vinSerial: orderDetails.vinSerial
    };

    const normalizedUpdatedVinSerial = (updatedOrder.vinSerial || '').trim().toLowerCase();
    const isDuplicateVinInRequest = normalizedUpdatedVinSerial.length > 0 && nonStandardEquipmentListTemp.some((item: any) =>
      item?.requestIndex !== editRequestDetails?.requestIndex &&
      (item?.vinSerial || '').trim().toLowerCase() === normalizedUpdatedVinSerial
    );

    const proceedUpdateItem = (syncCart: boolean, showUpdateToast: boolean) => {
      Array.isArray(nonStandardEquipmentListTemp) && nonStandardEquipmentListTemp.map((item: any) => {
        if (item?.requestIndex === editRequestDetails?.requestIndex) {
          item.make = orderDetails.make;
          item.model = orderDetails.model;
          item.year = orderDetails.year.value;
          item.isUsed = orderDetails.isUsed.value;
          item.vinSerial = orderDetails.vinSerial;
          item.pricePerUnit = orderDetails.pricePerUnit;
          item.description = orderDetails.description;
          item.abNumber = orderDetails.abNumber;
          item.vendorName = orderDetails.vendorName;
          item.dealerContact = orderDetails.dealerContact;
          item.dealerPhone = orderDetails.dealerPhone;
          item.emailAddress = orderDetails.emailAddress;
          item.address1 = orderDetails.address1;
          item.address2 = orderDetails.address2;
          item.address3 = orderDetails.address3;
          item.city = orderDetails.city;
          item.state = orderDetails.state;
          item.zip = orderDetails.zip;
        }
      })
      if (syncCart) {
        Array.isArray(nonStandardEquipmentCartListTemp) && nonStandardEquipmentCartListTemp.map((item: any) => {
          if (item?.requestIndex === editRequestDetails?.requestIndex) {
            item.make = orderDetails.make;
            item.model = orderDetails.model;
            item.year = orderDetails.year.value;
            item.isUsed = orderDetails.isUsed.value;
            item.vinSerial = orderDetails.vinSerial;
            item.pricePerUnit = orderDetails.pricePerUnit;
            item.description = orderDetails.description;
            item.abNumber = orderDetails.abNumber;
            item.vendorName = orderDetails.vendorName;
            item.dealerContact = orderDetails.dealerContact;
            item.dealerPhone = orderDetails.dealerPhone;
            item.emailAddress = orderDetails.emailAddress;
            item.address1 = orderDetails.address1;
            item.address2 = orderDetails.address2;
            item.address3 = orderDetails.address3;
            item.city = orderDetails.city;
            item.state = orderDetails.state;
            item.zip = orderDetails.zip;
          }
        })
      }

      const isDealerChangedInEdit = !isDealerDetailsEqual(editRequestDetails, orderDetails);
      if (isDealerChangedInEdit) {
        applyDealerDetailsToAllItems(nonStandardEquipmentListTemp, orderDetails);
        if (syncCart) {
          applyDealerDetailsToAllItems(nonStandardEquipmentCartListTemp, orderDetails);
        }
      }

      dispatch(RequisitionAction.setIsUpdateSuccessAlert(showUpdateToast))
      dispatch(RequisitionAction.setINonStandardEquipment(nonStandardEquipmentListTemp))
      if (syncCart) {
        dispatch(RequisitionAction.setCartINonStandardEquipment(nonStandardEquipmentCartListTemp))
      }
      dispatch(RequisitionAction.setIsEditRequestClick(false))
      dispatch(RequisitionAction.setEditRequestDetails({}))
      dispatch(setVinValidationResult(null));
    };

    const proceedUpdateItemWithDuplicateValidation = (syncCart: boolean, showUpdateToast: boolean) => {
      if (isDuplicateVinInRequest) {
        let description = (
          <>
            <p>{duplicateVinWarningMessage}</p>
          </>
        )
  
        setPopupContent({
          ...popupContent,
          titleImg: ConfirmationBee,
          title: "ALREADY EXISTS",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: description,
          primaryBtnText: "",
          outlineBtnText: "Ok",
          isSingleConfirmationBtn: true,
          popupOutlinebtnOnclick: () => {
            hideDialog();
            proceedUpdateItem(syncCart, showUpdateToast);
          },
          popupPrimarybtnOnclick: () => {
            hideDialog();
            proceedUpdateItem(syncCart, showUpdateToast);
          }
        });
        return;
      }

      proceedUpdateItem(syncCart, showUpdateToast);
    };

    const proceedUpdateItemWithDealerValidation = () => {
      const hasOtherRequestItems = nonStandardEquipmentListTemp.some((item: any) => item?.requestIndex !== editRequestDetails?.requestIndex);
      const hasOtherCartItems = nonStandardEquipmentCartListTemp.some((item: any) => item?.requestIndex !== editRequestDetails?.requestIndex);
      const isDealerChangedInEdit = !isDealerDetailsEqual(editRequestDetails, orderDetails);

      if (hasOtherCartItems && isDealerChangedInEdit) {
        showDealerPropagationConfirmationPopup(() => {
          proceedUpdateItemWithDuplicateValidation(true, true);
        });
        return;
      }
      if (hasOtherRequestItems && isDealerChangedInEdit) {
        showDealerPropagationPopup(() => {
          proceedUpdateItemWithDuplicateValidation(false, true);
        });
        return;
      }

      proceedUpdateItemWithDuplicateValidation(false, true);
    };

    proceedUpdateItemWithDealerValidation();
}
}

useEffect(() => {
  if (editRequestDetails?.requestType === CONSTANTS.NON_STANDARD_EQUIPMENT) {
    fieldFocus()
    dispatch(RequisitionAction.setIsUpdateSuccessAlert(false))
    const nonStandardEquipmentListTemp = cloneDeep(nonStandardEquipmentList) ?? [];

    Array.isArray(nonStandardEquipmentListTemp) && nonStandardEquipmentListTemp.map((item: any) => {
      if (item?.requestIndex === editRequestDetails?.requestIndex) {
        const orderDetailsTemp = { ...orderDetails };

        orderDetailsTemp.abNumber = editRequestDetails.abNumber;
        orderDetailsTemp.address1 = editRequestDetails.address1;
        orderDetailsTemp.address2 = editRequestDetails.address2;
        orderDetailsTemp.address3 = editRequestDetails.address3;
        orderDetailsTemp.city = editRequestDetails.city;
        orderDetailsTemp.dealerContact = editRequestDetails.dealerContact;
        orderDetailsTemp.dealerPhone = editRequestDetails.dealerPhone;
        orderDetailsTemp.description = editRequestDetails.description;
        orderDetailsTemp.emailAddress = editRequestDetails.emailAddress;
        orderDetailsTemp.make = editRequestDetails.make;
        orderDetailsTemp.model = editRequestDetails.model;
        orderDetailsTemp.pricePerUnit = editRequestDetails.pricePerUnit;
        orderDetailsTemp.state = editRequestDetails.state;
        orderDetailsTemp.vendorName = editRequestDetails.vendorName;
        orderDetailsTemp.vinSerial = editRequestDetails.vinSerial;
        orderDetailsTemp.zip = editRequestDetails.zip;

        // Store the original VIN value for comparison
        originalVinSerialRef.current = editRequestDetails.vinSerial || '';

        setVendor({
          key: editRequestDetails.abNumber,
          label: editRequestDetails.abNumber + "-" + editRequestDetails.vendorName,
          text: editRequestDetails.vendorName,
          value: editRequestDetails.vendorName
        })


        usedDropdownList?.forEach((item: any) => {
          if (editRequestDetails?.isUsed === item?.value) {
            orderDetailsTemp.isUsed = {
              label: item?.label,
              value: item?.value,
            }
          }
        })

        yearDropdownList?.forEach((item: any) => {
          if (editRequestDetails?.year === item?.value) {
            orderDetailsTemp.year = {
              label: item?.label,
              value: item?.value,
            }
          }
        })
        setOrderDetails(orderDetailsTemp)
      }
    })

  }
}, [editRequestDetails]);

const cancelEditRequestType = () => {
  dispatch(RequisitionAction.setEditRequestDetails({}))
  dispatch(RequisitionAction.setIsEditRequestClick(false))
  dispatch(setVinValidationResult(null));
}




  return <NonStandardEquipment
    yearDropdownList={yearDropdownList}
    usedDropdownList={usedDropdownList}
    vendorDropdownList={vendorDropdownList}
    addOnClick={addOnClick}
    orderDetails={orderDetails}
    nonStandardEquipmentValidation={nonStandardEquipmentValidation}
    popupContent={popupContent}
    hideDialog={hideDialog}
    onChangeMake={onChangeMake}
    onChangeModel={onChangeModel}
    onChangeYear={onChangeYear}
    onChangeIsUsed={onChangeIsUsed}
    onChangeVinSerial={onChangeVinSerial}
    onBlurVinSerial={onBlurVinSerial}
    vinValidationMessage={vinValidationResult?.message || ''}
    onChangePricePerUnit={onChangePricePerUnit}
    onChangeDescription={onChangeDescription}
    onChangeVendorName={onChangeVendorName}
    onChangeDealerContact={onChangeDealerContact}
    onChangeDealerPhone={onChangeDealerPhone}
    onChangeEmailAddress={onChangeEmailAddress}
    onChangeAddress1={onChangeAddress1}
    onChangeAddress2={onChangeAddress2}
    onChangeAddress3={onChangeAddress3}
    onChangeCity={onChangeCity}
    onChangeState={onChangeState}
    onChangeZip={onChangeZip}
    filterOptionVendor={filterOptionVendor}
    unitPriceFormat={unitPriceFormat}
    NonStandardRef={NonStandardRef}
    showDealerVendorPopup={showDealerVendorPopup}
    dealerVendorPopupClick={dealerVendorPopupClick}
    setShowDealerVendorPopup={setShowDealerVendorPopup}
    vendorSearchText={vendorSearchText}
    dealerSelectOnBlur={dealerSelectOnBlur}
    vendor={vendor}
    updateOnClick={updateOnClick}
    isEditRequestClick={isEditRequestClick}
    cancelEditRequestType={cancelEditRequestType}
  />
}

export default NonStandardEquipmentContainer;
